import type { MutateOptions, MutationOptions } from "@tanstack/react-query"
import type { Config } from "@wagmi/core"
import { Evaluate } from "viem"
import {
  type Permit2ErrorType,
  type Permit2Parameters,
  type Permit2ReturnType,
  permit2,
} from "../actions/permit2"

export function permit2MutationOptions<config extends Config>(config: config) {
  return {
    mutationFn(variables) {
      return permit2(config, variables)
    },
    mutationKey: ["permit2"],
  } satisfies MutationOptions<Permit2Data, Permit2ErrorType, Permit2Variables>
}

export type Permit2Data = Evaluate<Permit2ReturnType>

export type Permit2Variables = Permit2Parameters

export type Permit2Mutate<context = unknown> = (
  variables: Permit2Variables,
  options?:
    | MutateOptions<Permit2Data, Permit2ErrorType, Permit2Variables, context>
    | undefined,
) => void

export type Permit2MutateAsync<context = unknown> = (
  variables: Permit2Variables,
  options?:
    | MutateOptions<Permit2Data, Permit2ErrorType, Permit2Variables, context>
    | undefined,
) => Promise<Permit2Data>
